import { HttpContext, HttpContextToken } from '@angular/common/http';
import { SKIP_GLOBAL_LOADING_CONTEXT_TOKEN } from '../tokens';

export const SKIP_GLOBAL_LOADING_CONTEXT = new HttpContext().set(
  SKIP_GLOBAL_LOADING_CONTEXT_TOKEN,
  'skip',
);

export const NO_LOADING = new HttpContextToken(() => true);